export default __webpack_public_path__ + "static/media/SelfServiceKiosk8.0d93ffd6.png";